import {Col, Row} from 'antd';
import React from 'react';

import InformativeText from '../../../../../../constants/InformativeText';
import {convertPxToRem} from '../../../../../../utils/commonFunctions';
import AllFacilityDisplay from '../../../../components/AllFacilityDisplay';
import TotalChartList from '../../../../components/TotalChartList';
import ValueRepresentationBox from '../../../../components/ValueRepresentationBox';
import {rowGutterNZM} from '../../../../constants/commonConstants';

const ConsumptionElec: React.FC<{data: any[]}> = ({data}) => {
  const elecInfo = InformativeText?.NZM?.utility?.electricity;

  return (
    <>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(499)}}>
        <Col span={24}>
          <TotalChartList
            chartType="lineMinMax"
            showTotal={false}
            keyArray={['electricity consumption trends over time']}
            data={data}
            dataInMainData={true}
            showChartList={false}
          />
        </Col>
      </Row>
      <Row gutter={rowGutterNZM} style={{height: convertPxToRem(996)}}>
        <Col span={10}>
          <Row gutter={rowGutterNZM} style={{height: convertPxToRem(654)}}>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="electricity consumption per employee"
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="electricity consumption per unit of revenue"
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="electricity consumption intensity"
                tooltip={elecInfo?.Electricity_consumption_intensity}
              />
            </Col>
            <Col span={12}>
              <ValueRepresentationBox
                data={data}
                mainKey="electricity consumption per sq m of floor area"
              />
            </Col>
          </Row>
          <Row gutter={rowGutterNZM} style={{marginTop: convertPxToRem(24), height: convertPxToRem(318)}}>
            <Col span={24} style={{height: '100%'}}>
              <TotalChartList
                data={data}
                keyArray={[
                  'Total electricity consumption',
                  'Renewable Electricity consumption',
                  'Non-Renewable Electricity consumption'
                ]}
                chartType="pie"
              />
            </Col>
          </Row>
        </Col>
        <Col span={14} style={{height: '100%'}}>
          <AllFacilityDisplay
            data={data}
            keyArray={['consumption by facility']}
            type="electricCon"
            showFilter={false}
            isSingle={true}
            customTitle="TOTAL ELECTRICITY CONSUMPTION"
            customCalKey="value"
          />
        </Col>
      </Row>
    </>
  );
};

export default ConsumptionElec;
